import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchProductMeasurementTypes } from '../../../../actions/product/productMeasurementTypeList'
import { AppState } from '../../../../reducers'
import { FiltersBar, FilterTextField } from '../../../Utils/Filters/Filter'
import { useTranslation } from 'react-i18next'
import { ProductMeasurementTypeListState } from '../../../../reducers/product/productMeasurementTypeList'
import { Button, Stack } from '@mui/material'
import ProductMeasurementType from '../../../../models/ProductMeasurementType'
import ProductMeasurementTypes from '../ProductMeasurementTypes'

interface Props {
  fullInfo?: boolean
  productMeasurementTypeList: ProductMeasurementTypeListState
}

const ProductMeasurementTypeList: React.FC<Props> = ({ productMeasurementTypeList }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('product')
  const [edit,] = useState(false)

  useEffect(() => {
    dispatch(fetchProductMeasurementTypes(history.location.search))
  }, [dispatch, history.location.search, edit])


  const linkToProductMeasurementTypeEdit = (productMeasurementType: ProductMeasurementType) => {
    const editUrl = `/admin/productMeasurementTypes/update/${productMeasurementType.id}`
    history.push(editUrl, { update: edit })
  }

  return (
    <div>
      <FiltersBar>
        <FilterTextField style={{marginRight:"10px"}} name="code" label={t("code")} />
        <FilterTextField style={{maxWidth:"400px", width:"400px", marginRight:"10px"}} name="description" label={t("description")} />
      </FiltersBar>
      <ProductMeasurementTypes
        rows={(productMeasurementTypeList.productMeasurementTypes || []).map(s => ({ data: s }))}
        loading={productMeasurementTypeList.isFetching}
        pagination={productMeasurementTypeList.pagination || undefined}
        onClickInfo={linkToProductMeasurementTypeEdit}
      />

      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="back" size='large' style={{ textTransform: 'none' }}  onClick={() => history.push('/admin/productMeasurementTypes/create', { title: t('create') })}>
        {`${t('create')}${t('measurementType')}`}
        </Button>
      </Stack>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  productMeasurementTypeList: state.productMeasurementTypeList,
})

export default connect(mapStateToProps, null)(ProductMeasurementTypeList)